import NodeController05ABI from "@abi/NodeController05";
import type { Address } from "viem";
import { useReadContract } from "wagmi";
import useContract from "./useContract";
export const useTotalValueLocked = () => {
	const { nodeController05Contract } = useContract();
	const { data: result } = useReadContract({
		abi: NodeController05ABI,
		address: nodeController05Contract.address as Address,
		functionName: "getTotalValueLocked",
	});

	return result?.toString() ?? "0";
};
